module.exports = __webpack_public_path__ + "img/star-1.488285fc.svg";